import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-navy-950 py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-126" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-127" data-mp="1dxt7p0idz4i7">
        <div className="text-center" data-id="element-128" data-mp="2bk8pk3eq646a">
          <span className="inline-flex items-center gap-2 rounded-md border border-silver-400/40 bg-navy-800 px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-silver-100" data-id="element-129" data-mp="2bj7dpwpvxdni">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-130" data-mp="21l9r1dnobox0" /> Material completo para el aula
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-131" data-mp="1wly9i2fhgfed">
            Los {totalVolumes} tomos del Megapack
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-132" data-mp="l7b6k5183d7f">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-silver-400/25 bg-navy-900 shadow-sm shadow-black/20" data-id="element-133" data-mp="1ite6ikvvw50x" data-mpi={index}>
                <div className="flex min-h-[104px] items-center gap-4 border-b border-silver-400/25 bg-navy-800 px-6 py-5" data-id="element-134" data-mp="14x0mb3zytpir">
                  <span className="metal-silver flex h-12 w-12 shrink-0 items-center justify-center rounded-md text-navy-950" data-id="element-135" data-mp="q4qf07kjkjex">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-136" data-mp="h64wudizf6eo" />
                  </span>
                  <div data-id="element-137" data-mp="l78g7a08nkkn">
                    <p className="text-[11px] font-extrabold uppercase tracking-[.18em] text-silver-300" data-id="element-138" data-mp="l7q9pyvinkov">
                      Tomo {module.number}
                    </p>
                    <h3 className="mt-1 text-lg font-extrabold leading-tight text-white" data-id="element-139" data-mp="2j3oyyqb7ejes">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-140" data-mp="2e4vicp0mecae">
                  <p className="font-semibold text-silver-100" data-id="element-141" data-mp="295r9y0lisil4">{module.subtitle}</p>

                  <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[.16em] text-silver-400" data-id="element-142" data-mp="36srf1tq6w476">
                    ¿Qué resuelve en el aula?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-silver-200" data-id="element-143" data-mp="31s3p7bdp5tej">{module.classroom}</p>

                  <ul className="mt-5 grid flex-1 content-start gap-2" data-id="element-144" data-mp="2wwocwnvc85k8">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-silver-100" data-id="element-145" data-mp="1lfexqdj8rzoq">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-silver-300" aria-hidden="true" data-id="element-146" data-mp="1hebj1ucxk9p3" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-silver-300 bg-navy-950 p-4 text-sm leading-relaxed text-silver-100" data-id="element-147" data-mp="x49i6iw3jg6">
                    <b className="font-extrabold text-white" data-id="element-148" data-mp="5v5xn5v6a8yi">Resultado: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl border border-silver-400/30 bg-navy-800 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-149" data-mp="fov2rxbsalb9">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-silver-300" data-id="element-150" data-mp="oo00j1fiuamd">Colección principal</p>
          <p className="font-serif text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-151" data-mp="tk76uvbtxo4u">
            {totalVolumes} tomos premium <span className="mx-2 text-silver-400" data-id="element-152" data-mp="2vdel01fphzp5">·</span> Contenido actualizado 2026
          </p>
        </div>
      </div>
    </section>;
}